import React, { useState, useEffect, useRef } from "react";
import { useLocation, useHistory, useParams } from "react-router-dom";
import { Icon } from "@iconify/react";
import axios from "axios";
import {
  Table,
  Button,
  Select,
  Row,
  Col,
  Input,
  DatePicker,
  Menu,
  Space,
  Card,
  Checkbox,
} from "antd";
import moment from "moment";
import ReactToPrint from "react-to-print";
import HeaderBar from "../../../components/header/headerBar";
import OpdPrint from "./printForMedicine";
import ModalMedicine from "../detail/doctor/modalMedicine";
import { CheckBox } from "../../../components/textfield";

interface ParamTypes {
  id?: string;
}

const PrintLabelDrugs = () => {
  const { Option } = Select;
  const { id } = useParams<ParamTypes>();
  const navigate = useHistory();
  const [dataSearch, setDataSearch] = useState<any>([]);
  const [nameTitle, setNameTitle] = useState<string>("");
  const [dataMedicine, setDataMedicine] = useState<any>([]);
  const [dataPrint, setDataPrint] = useState<any>([]);
  const [nameTitle1, setNameTitle1] = useState<string>("");
  const [checkedCate, setCheckedCate] = useState<any>("CustomerName");

  const columns = [
    {
      title: "",
      dataIndex: "index",
      width: "1%",
      key: 1,
    },
    {
      title: "CN",
      dataIndex: "code",
      width: "5%",
      key: 2,
    },
    {
      title: "ยากิน",
      width: "4%",
      align: "center" as const,
      key: 3,
      render: (data: any) => {
        return (
          <div>
            <Checkbox
              onChange={(e: any) => {
                const xcheck = dataMedicine.map((x: any) => ({
                  ...x,
                  mediEat: e.target.checked,
                }));
                setDataMedicine(xcheck);
              }}
            />
          </div>
        );
      },
    },
    {
      title: "ยาทา.",
      align: "center" as const,
      width: "3%",
      key: 4,
      render: (data: any) => {
        return (
          <div>
            <Checkbox
              onChange={(e: any) => {
                const xcheck = dataMedicine.map((x: any) => ({
                  ...x,
                  vanishing: e.target.checked,
                }));
                setDataMedicine(xcheck);
              }}
            />
          </div>
        );
      },
    },
    {
      title: "Name",
      dataIndex: "name",
      width: "15%",
      key: 5,
    },
    {
      title: "Details",
      dataIndex: "detail",
      width: "5%",
      key: 6,
    },
    {
      title: "หน่วย",
      dataIndex: "unit",
      align: "center" as const,
      width: "2%",
      key: 7,
    },
    {
      title: "รับประทานครั้งละ/ Take pill(s) per time",
      dataIndex: "pilltime",
      align: "center" as const,
      width: "5%",
      key: 8,
      render: (data: any) => {
        return (
          <div>
            <Input
              type="number"
              onChange={(e: any) => {
                const xcheck = dataMedicine.map((x: any) => ({
                  ...x,
                  Takepill: e.target.value,
                }));
                setDataMedicine(xcheck);
              }}
            ></Input>
          </div>
        );
      },
    },
    {
      title: "วันละ/ Per Day",
      dataIndex: "perday",
      align: "center" as const,
      width: "4%",
      key: 9,
      render: (data: any) => {
        return (
          <div>
            <Input
              type="number"
              onChange={(e: any) => {
                const xcheck = dataMedicine.map((x: any) => ({
                  ...x,
                  PerDay: e.target.value,
                }));
                setDataMedicine(xcheck);
              }}
            ></Input>
          </div>
        );
      },
    },
    {
      title: "ก่อนอาหาร/ Before Meal",
      align: "center" as const,
      width: "5%",
      key: 10,
      render: (data: any) => {
        return (
          <div>
            <Checkbox
              onChange={(e: any) => {
                const xcheck = dataMedicine.map((x: any) => ({
                  ...x,
                  BeforeMeal: e.target.checked,
                }));
                setDataMedicine(xcheck);
              }}
            />
          </div>
        );
      },
    },
    {
      title: "หลังอาหาร/ After Meal",
      align: "center" as const,
      width: "5%",
      key: 11,
      render: (data: any) => {
        return (
          <div>
            <Checkbox
              onChange={(e: any) => {
                const xcheck = dataMedicine.map((x: any) => ({
                  ...x,
                  afterMeal: e.target.checked,
                }));
                setDataMedicine(xcheck);
              }}
            />
          </div>
        );
      },
    },
    {
      title: "เช้า",
      align: "center" as const,
      width: "1%",
      key: 12,
      render: (data: any) => {
        return (
          <div>
            <Checkbox
              onChange={(e: any) => {
                const xcheck = dataMedicine.map((x: any) => ({
                  ...x,
                  morning: e.target.checked,
                }));
                setDataMedicine(xcheck);
              }}
            />
          </div>
        );
      },
    },
    {
      title: "กลางวัน",
      align: "center" as const,
      width: "4%",
      key: 13,
      render: (data: any) => {
        return (
          <div>
            <Checkbox
              onChange={(e: any) => {
                const xcheck = dataMedicine.map((x: any) => ({
                  ...x,
                  noon: e.target.checked,
                }));
                setDataMedicine(xcheck);
              }}
            />
          </div>
        );
      },
    },
    {
      title: "เย็น",
      width: "1%",
      align: "center" as const,
      key: 14,
      render: (data: any) => {
        return (
          <div>
            <Checkbox
              onChange={(e: any) => {
                const xcheck = dataMedicine.map((x: any) => ({
                  ...x,
                  evening: e.target.checked,
                }));
                setDataMedicine(xcheck);
              }}
            />
          </div>
        );
      },
    },
    {
      title: "ก่อนนอน",
      width: "4%",
      align: "center" as const,
      key: 15,
      render: (data: any) => {
        return (
          <div>
            <Checkbox
              onChange={(e: any) => {
                const xcheck = dataMedicine.map((x: any) => ({
                  ...x,
                  bedtime: e.target.checked,
                }));
                setDataMedicine(xcheck);
              }}
            />
          </div>
        );
      },
    },
  ];

  const getPersonal = async () => {
    await axios.get(`/member-opd/${id}`).then((res) => {
      getData(res?.data);
    });
  };

  const getDataMedicine = (values: any) => {
    console.log("nameTitle1", nameTitle1);

    // const data = [];

    // const xdata = {

    // };
    // data.push(xdata);

    // console.log("xdata=>>>>", data);
    // setDataMedicine(data);
  };
  const onChange = (value: any, event: any) => {
    console.log("values onchange", value + "======" + event);
  };

  const checkName = (e: any) => {
    console.log("e", e);
    setCheckedCate(e);
  };

  const getData = async (data: any) => {
    let prefix = "";

    // let difference = moment().diff(data?.birthDate)
    // let duration = moment.duration(difference);
    // let year =  duration.years()
    // let day = duration.days()
    // let month = duration.months()

    await axios.get(`/prefixes/${data?.prefix}`).then((res) => {
      prefix = res?.data?.name;
      setNameTitle(
        `รายการยา / ${res?.data?.name}${data?.firstName} ${data?.lastName} (${data?.code})`
      );
      setNameTitle1(
        `${res?.data?.name}${data?.firstName} ${data?.lastName} (${data?.code})`
      );
    });
  };

  useEffect(() => {
    getPersonal();
    getDataMedicine({
      ...dataMedicine,
      // mediEat: false,
      // vanishing: false,
      Takepill: "",
      PerDay: "",
      // BeforeMeal: false,
      // afterMeal: false,
      // morning: false,
      // noon: false,
      // evening: false,
      // bedtime: false,
      title: "",
    });
    // getDataMedicine();
  }, []);

  useEffect(() => {
    console.log("dataMedicine", dataMedicine);
  }, [dataMedicine]);

  useEffect(() => {
    console.log("checkedCate", checkedCate);
  }, [checkedCate]);

  const optTitle = [
    {
      key: "CustomerName",
      value: "CustomerName",
      name: "ใส่ชื่อ/Customer Name",
    },
    {
      key: "NotName",
      value: "NotName",
      name: "ไม่ใส่ชื่อ/No Name",
    },
  ];

  return (
    <div className="opd-table-list">
      <HeaderBar title={`${nameTitle}`} btnBack={true}></HeaderBar>
      <div style={{ margin: "10px 40px" }}>
        <Card>
          <Row style={{ marginBottom: "30px" }}>
            <Col span={12}>
              <div className="heading">
                <p>ชื่อลูกค้า/Customer Name</p>
              </div>
              <Select
                placeholder="ใส่ชื่อ/Customer Name"
                defaultValue={"CustomerName"}
                style={{ width: "50%" }}
                suffixIcon={<Icon icon="ant-design:caret-down-filled" />}
                // defaultValue="เลือก"
                onChange={(e: any) => {
                  // console.log("e cuss", e);
                  // setCheckedCate(e);
                  checkName(e);
                  // setDataMedicine({ ...dataMedicine, title: e });
                }}
              >
                {optTitle.map((item: any) => (
                  <Option value={item.value}>{item.name}</Option>
                ))}
              </Select>
            </Col>
            <Col span={12} style={{ textAlign: "end", alignSelf: "center" }}>
              {/* <Button
                  type="primary"
                  style={{ width: "177px" }}
                  // onClick={(e) => navigate.push(`${route}/opd/so`)}
                >
                  เพิ่มรายการ/Add Order
                </Button> */}
              <ModalMedicine dataMedicine={getDataMedicine} />
            </Col>
          </Row>

          <Row>
            <Col>
              <h5>รายการยาที่เลือก/List of selected medicine.</h5>
            </Col>
          </Row>

          <div className="table-data-medicine">
            <Table
              columns={columns}
              dataSource={dataMedicine}
              bordered
              scroll={{ x: 1500 }}
            />
          </div>
        </Card>
      </div>
      <div style={{ display: "flex", justifyContent: "center", marginTop: 35 }}>
        {dataMedicine.length > 0 && (
          <Space align="center">
            <OpdPrint
              ComponentRef="opdPrint"
              title="Print THAI"
              dataOpdPrint={dataMedicine}
              type="medicine-thai"
              color="#5BAEA9"
              nameTitle={nameTitle1}
            />
            <OpdPrint
              ComponentRef="opdPrint"
              title="Print ENG"
              dataOpdPrint={dataMedicine}
              type="medicine-eng"
              color="#4D7E7F"
              nameTitle={nameTitle1}
            />
          </Space>
        )}
      </div>
    </div>
  );
};
export default PrintLabelDrugs;
